export default __webpack_public_path__ + "static/media/arrow_drop_down-Disable.e6c0dee3.svg";